import { useEffect, useState } from "react";
// import * as yup from "yup";
import { Dialog } from "primereact/dialog";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { baseUrl, Fetch } from "../../../shared/Fetch";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { safeFormatDate } from "../../../models/DateFormatMapper";
import { ILogin } from "../../../models/Login";

// interface IForm {
//   title?: string;
// }

interface IProps {
  open: boolean;
  singleData: any;
  toast: any;
  onHide: () => void;
}

// const schema = yup.object({
//   title: yup.string().trim().required("Title is required"),
// });

export const DocumentList = (props: IProps) => {
  const [documents, setDocuments] = useState<any[]>([]);

  const loadDocuments = async (id: number) => {
    const response = await Fetch(`Tender_Mast/GetTenderDocuments/${id}`, "GET", null, null, props.toast);
    if (response?.ok) {
      const data = await response.json();
      setDocuments(data);
    }
  };
  const loginObj: ILogin = JSON.parse(sessionStorage.getItem("auth") + "");
  let _roles: Array<number> = [];
  loginObj.roles.forEach((role) => {
    _roles.push(role.role_ID);
  });
  const DateFormat = loginObj.date_Format;

  const downloadDoc = async (rowData: any) => {
    const documentID: number = rowData.id;
    const options = {
      method: "GET",
      headers: {
        Authorization: `Bearer ${JSON.parse(sessionStorage.getItem("auth") + "")?.token}`,
      },
    };
    try {
      const response = await fetch(`${baseUrl}Tender_Mast/DownloadTenderDocument?documentID=${documentID}`, options);

      if (response.status === 200) {
        const blob = await response.blob();
        const disposition = response.headers.get("content-disposition");
        let fileName = rowData.title;

        if (disposition) {
          const match = disposition.match(/filename="?([^"]+)"?/);
          if (match?.[1]) fileName = match[1];
        }

        const href = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = href;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(href);
      } else {
        const msg = await response.text();
        props.toast?.current?.show({ severity: "error", summary: "Error", detail: msg, life: 3000 });
      }
    } catch {
      props.toast?.current?.show({ severity: "error", summary: "Error", detail: "Something went wrong", life: 3000 });
    }
  };

  const deleteDoc = (documentID: number) => {
    confirmDialog({
      header: "Delete Document",
      message: "Are you sure you want to delete this document?",
      icon: "pi pi-exclamation-triangle",
      acceptClassName: "p-button-danger",
      acceptLabel: "Delete",
      rejectLabel: "Cancel",
      accept: async () => {
        const response = await Fetch(`Tender_Mast/DeleteTenderDocument/${documentID}`, "DELETE", null, null, props.toast);

        if (response?.ok) {
          props.toast.current.show({ severity: "success", summary: "Success", detail: "Document Deleted Successfully", life: 3000 });
          loadDocuments(props.singleData!.id);
        } else {
          const msg = await response?.text();
          props.toast.current.show({ severity: "error", summary: "Error", detail: msg || "Delete failed", life: 3000 });
        }
      },
    });
  };

  const downloadBody = (rowData: any) => {
    return rowData.doc_Path ? <Button icon="pi pi-download" className="p-button-rounded p-button-success p-button-text" tooltip="Download" onClick={() => downloadDoc(rowData)} /> : null;
  };

  const deleteBody = (rowData: any) => {
    return <Button icon="pi pi-trash" className="p-button-rounded p-button-danger p-button-text" tooltip="Delete" onClick={() => deleteDoc(rowData.id)} />;
  };

  useEffect(() => {
    if (props.open && props.singleData?.id) {
      loadDocuments(props.singleData.id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.open, props.singleData]);

  const onHide = () => {
    props.onHide();
  };
  const documentCount = documents.length;

  return (
    <>
      <ConfirmDialog />
      <Dialog visible={props.open} onHide={onHide} header="RFP Documents" style={{ width: "60rem" }} modal>
        <DataTable value={documents} responsiveLayout="scroll" stripedRows>
          <Column header="SN" body={(rowData, options) => options.rowIndex + 1} />
          <Column field="title" header="Document Title" />
          <Column field="added_On" header="Added On" body={(rowData: any) => safeFormatDate(rowData.added_On, "dd/MM/yyyy", DateFormat)} style={{ maxWidth: "120px" }} />
          <Column header="Download" body={downloadBody} />
          {(_roles.includes(54) || _roles.includes(1) || _roles.includes(56))  && documentCount >= 2 &&(<Column header="Delete" body={deleteBody} />)}
        </DataTable>
      </Dialog>
    </>
  );
};
